<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container
      ><material-card
        v-if="equipmentProfile && equipmentProfile.equipTag"
        icon="mdi-alarm-light"
        color="primary"
        inline
        class="px-5 my-12 py-3"
      >
        <template v-slot:after-heading>
          <div
            v-if="equipmentProfile && equipmentProfile.equipTag"
            class="title text-no-wrap font-weight-bold"
          >
            {{ $t("equipmentProfile.equipment") }}
            Variables
          </div>
        </template>
        <!--  <ranges-table></ranges-table> -->
        <auto-complete></auto-complete>
        <input-ranges @save-tag="updateSlider"></input-ranges>
        <v-card-actions class="my-4">
          <v-spacer></v-spacer>
          <v-btn
            :x-large="$vuetify.breakpoint.mdAndUp"
            width="250"
            rounded
            :disabled="!$store.getters['auth/adminAndUp']"
            color="primary"
            @click="updateSlider"
            >{{ $t("dashboard.updateRanges") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions> </material-card></v-container
  ></v-container>
</template>

<script>
import { mapState } from "vuex";

import { db } from "@/plugins/db";
import { unitDefault } from "@/settings/unitTypes";
import readValues from "@/mixins/readValues";
import writeValues from "@/mixins/writeValues";
export default {
  mixins: [readValues, writeValues],
  data() {
    return {
      unitRules: [v => !!v || "Unit is required"],
      areaRules: [v => !!v || "Area is required"],
      plantRules: [v => !!v || "Plant is required"],
      disabledAreas: true,
      disabledUnits: true,
      clientRules: [v => !!v || "Customer is required"],
      contract: [{ name: "Type A" }, { name: "Type B" }],
      status: [
        { name: "Active", value: true },
        { name: "Inactive", value: false }
      ]
    };
  },
  components: {
    "auto-complete": () => import("./AutoComplete"),
    "material-card": () => import("@/components/MaterialCard.vue"),
    /*   "ranges-table": () => import("./RangesTable.vue"), */
    "input-ranges": () => import("./InputRanges/Index.vue")
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"]),

    isPump() {
      return this.equipmentProfile.isPump;
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square",
      text: ""
    });
    try {
      await this.$store.dispatch(
        "equipments/bindAnEquipment",
        this.$route.params.id
      );
      await this.$store.dispatch("events/bindEvents", this.$route.params.id);
      this.setValues();
      loading.close();
    } catch (error) {
      console.error(error);
      this.$dialog.notify.error(error, {
        position: "top-right",
        timeout: 5000
      });
    }
  },

  methods: {
    setUnit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    },

    transformValue(variable) {
      // transforma la variable si no es metrico a metrico.
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.setUnit(variable?.type);
        return parseFloat(this.saveUnit(variable?.value, variable?.type, unit));
      }
    },
    saveMin(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.min);
      } else {
        let unit = this.setUnit(variable?.type);
        return parseFloat(this.saveUnit(variable.min, variable?.type, unit));
      }
    },
    saveMax(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.max);
      } else {
        let unit = this.setUnit(variable?.type);
        return parseFloat(this.saveUnit(variable.max, variable?.type, unit));
      }
    },
    saveValues(variable) {
      if (this.isMetric) {
        return variable?.values;
      } else {
        let unit = this.setUnit(variable?.type);
        variable.values;
        const newValues = variable?.values?.map(rango => {
          const newRango = parseFloat(
            this.saveUnit(rango, variable?.type, unit)
          );

          return newRango;
        });
        return newValues;
      }
    },
    readMin(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.min);
      } else {
        let unit = this.setUnit(variable?.type);
        return parseFloat(
          this.transformUnit(variable.min, variable?.type, unit).toFixed(2)
        );
      }
    },
    readMax(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.max);
      } else {
        let unit = this.setUnit(variable?.type);
        return parseFloat(
          this.transformUnit(variable.max, variable?.type, unit).toFixed(2)
        );
      }
    },
    readValores(variable) {
      if (this.isMetric) {
        return variable?.values;
      } else {
        let unit = this.setUnit(variable?.type);
        variable.values;

        const newValues = variable?.values?.map(rango => {
          const newRango = parseFloat(
            this.transformUnit(rango, variable?.type, unit).toFixed(2)
          );
          return newRango;
        });

        return newValues;
      }
    },
    setValues() {
      let dis = this;
      let data = dis.equipmentProfile?.variables;
      data.forEach(v => {
        v.values = v.type === "steps" ? v.values : dis.readValores(v);
        v.min = v.type === "steps" ? v.min : dis.readMin(v);
        v.max = v.type === "steps" ? v.max : dis.readMax(v);
        // transforma la variable si no es metrico a metrico.
      });
    },
    async updateSlider() {
      const dis = this;
      const loading = dis.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });

      dis.equipmentProfile?.variables?.forEach(variable => {
        variable.values =
          variable.type === "steps"
            ? variable.values
            : dis.saveValues(variable);
        variable.min =
          variable.type === "steps"
            ? variable.values
            : parseFloat(dis.saveMin(variable));
        variable.max =
          variable.type === "steps"
            ? variable.values
            : parseFloat(dis.saveMax(variable));
      });

      try {
        await db
          .collection("equipments")
          .doc(this.equipmentProfile.id)
          .update({
            variables: this.equipmentProfile.variables
          });
        this.setValues();
        this.$dialog.notify.success("Range was updated successfully", {
          position: "top-right",
          timeout: 5000
        });
        this.$emit("setValues");
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style scoped></style>
